import $ from "jquery";
import { Splide } from "@splidejs/splide";

const latestNewsSlider = () => {
    if ($(".js-latest-news-slider").length) {
        $(".js-latest-news-slider").not(".is-initialized").each(function (index, sliderElement) {
            var config = {
                type: "loop",
                pagination: false,
                arrows: true,
                gap: "2.5rem",
                autoWidth: true,
                focus: "center",
            };
            var slider = new Splide(sliderElement, config);

            slider.mount();
        });
    }
};

export default latestNewsSlider;
